import React, { useRef, useState } from "react";
import plastiq from "../../assets/img/logo/plastiq.png";
import play_btn from "../../assets/img/play_btn.png";
import thumbnail from "../../assets/img/thumbnel.png";
import video from "../../assets/video/video.mp4";

export default function FundingLiquidate() {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleTogglePlay = () => {
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="funding_overview mt-3 tradelines">
      <div className="funding_common_area">
        <div className="content">
          <h3>
            Debt Relief: Combine All Debts into a Single Loan, Lower Utilization
          </h3>
          <div className="video-container relative mt-3">
            <video
              ref={videoRef}
              src={video}
              className="video"
              onClick={handleTogglePlay}
              preload="metadata"
            />
            {/* Thumbnail overlay */}
            {!isPlaying && (
              <div className="thumbnail-overlay flex justify-center items-center">
                <img
                  src={thumbnail}
                  alt="Video Thumbnail"
                  className="thumbnail"
                />
                <div className="play-button" onClick={handleTogglePlay}>
                  <img className="icons" src={play_btn} alt="" />
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="card">
          <div className="img_area">
            <img src={plastiq} alt="" />
          </div>
          <div className="mt-4 text-center">
            <h3>Instantly turn credit into Cash</h3>
            <p className="mt-2">
              Pay by credit card and have money sent to your bank account via
              ACH Transfer
            </p>
          </div>
          <button className="btn mt-3">Get Started!</button>
        </div>
      </div>
    </div>
  );
}
